'use client';

import React from "react";
import "../assets/styles/KaggleSection.scss";
import ScienceIcon from '@mui/icons-material/Science';
import BarChartIcon from '@mui/icons-material/BarChart';
import TimelineIcon from '@mui/icons-material/Timeline';
import InsightsIcon from '@mui/icons-material/Insights';
import TerminalIcon from '@mui/icons-material/Terminal';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import MemoryIcon from '@mui/icons-material/Memory';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import ImageIcon from '@mui/icons-material/Image';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import BookIcon from '@mui/icons-material/Book';

const featuredNotebook = {
  title: "Fastai Production",
  description: "Implemented Tanishq Belog with function updates, Gradio UI changes, `app.py` enhancements, and successfully deployed the application on Kaggle via Git.",
  url: "https://www.kaggle.com/code/ahmadhassan061/lec2-fastai-production",
};

const notebooks = [
  {
    title: "DL1: Deep Learning Code First",
    url: "https://www.kaggle.com/work/collections/16453301",
    tags: ["Tabular", "Resnet", "Image-localisation","Classification","CollabDataLoaders","Fastai", "Segmentation", "CollaborativeFilter", "vision_learner" , "image_datablock", "DuckDuckGo"],
    icon: <TerminalIcon />,  
  },
  {
    title: "DL2: Deep Learning Production",
    url: "https://www.kaggle.com/work/collections/16453180",
    tags: ["HuggingFace", "Gradio", "Classification", "Fastai", "MLOps"],
    icon: <CloudDoneIcon />,  
  },
  {
    title: "DL3: Neural Network From Scratch Using Fastai PyTorch",
    url: "https://www.kaggle.com/work/collections/16453413",
    tags: ["Neural-Network", "Scratch", "Titanic", "Mnist", "MLOps","NLP", "PyTorch"],
    icon: <MemoryIcon />,
  },
  {
    title: "DL4: Natural Language Processing",
    url: "https://www.kaggle.com/work/collections/16453504",
    tags: ["AWD_LSTM", "NLP", "Tokenization", "textBlock","LMDataLoader", "GPT","LLM from Scratch","Text-Generation","GenAI", "Semantic-Classification", "Fastai", "Fine-Tuning","Encoder-Decoder", "US-Patent Phrase Matching"],
    icon: <TextSnippetIcon />, 
 },
    {
    title: "DL5: Linear Regression & Random Forest From Scratch With Titanic Data",
    url: "https://www.kaggle.com/work/collections/16453871",
    tags: ["Titanic-Dataset", "Feature Engineering", "Random Forest", "Sigmoid","Gradient", "Kaggle","Competition","Pre-processing", "Fastai","Tensors"],
    icon: <BarChartIcon />,
  },

  {
    title: "DL6: Deep Dive to Random Forest",
    url: "https://www.kaggle.com/work/collections/16453926",
    tags: ["Tabular", "Gini", "Gradient-Boosting", "Out-of-Bag", "Feature-Importance-plot","FASTKaggle-Library", "SHAP","LIME","Ensemble", "Over-Fitting","Fastcore.parallel","Partial-dependency"],
    icon: <ScatterPlotIcon />,
  },

  {
    title: "DL7: Deep Dive to Collaborative Filtering with Recommendation System",
    url: "https://www.kaggle.com/work/collections/16453933",
    tags: ["convnext", "Gradient-Boosting", "Binary Cross Entropy", "Handle xLarge Model in Kaggle","Cuda out of memory", "Stochastic Gradient Descent","Embedding from Scratch","Create Latent Factors", "Weight Decay","L2 Regularisation","Visualisation"],
    icon: <GroupWorkIcon />,
  },

  {
    title: "DL8: Image Classification From Scratch & Collaborative Filtering",
    url: "https://www.kaggle.com/work/collections/16453936",
    tags: ["TabularLearner", "Random Forest Usage For Collab", "Collab Filtering with pytorch", "Embedding Distance","PCA", "Stochastic Gradient Descent","creating embeddings","Derivatives", "Relu vs Sigmoid","Numpy","MNIST"],
    icon: <ImageIcon />,
  },
  {
    title: "DL9: Stable Diffusion",
    url: "https://www.kaggle.com/work/collections/16453938",
    tags: ["DALL-E 2", "Hugging Face : Diffusers library", "Embeddings"],
    icon: <AutoAwesomeIcon />,
  }
];

const notebooks1 = [

  {
    title: "Fastbook: Fastai Mid-Level API on Top of Pytorch",
    url: "https://www.kaggle.com/work/collections/16586576",
    tags: ["Data Munging", "Transform", "SiamesePair", "Pytorch", "Classes", "Scratch", "Dataloaders", "Dataset"],
    icon: <BookIcon />,
  },

  {
    title: "Fastbook: Convolutional Neural Networks",
    url: "https://www.kaggle.com/work/collections/16628258",
    tags: ["Convnet", "Convolutions", "Neural", "Network", "Scratch", "Padding"],
    icon: <BookIcon />,
  },
  
{
    title: "Fastbook: Residual Neural Networks",
    url: "https://www.kaggle.com/work/collections/16722244",
    tags: ["Resnet"],
    icon: <BookIcon />,
  },

];


const notebooks2 = [
  {
    title: "Skin Lesion Classification with CNN",
    url: "https://www.kaggle.com/code/ahmadskin/skin-lesion-classification",
    tags: ["Medical", "CNN", "Image"],
    icon: <ScienceIcon />,
    collection: "Medical AI",
  },
  {
    title: "Random Forest Clustering",
    url: "https://www.kaggle.com/code/ahmadforest/random-forest-clustering",
    tags: ["Clustering", "Random Forest", "ML"],
    icon: <BarChartIcon />,
    collection: "Tree-Based Models",
  },
  {
    title: "Time Series Forecasting with LSTM",
    url: "https://www.kaggle.com/code/ahmadlstm/time-series-forecasting",
    tags: ["LSTM", "Forecasting", "Time Series"],
    icon: <TimelineIcon />,
    collection: "Time Series",
  },
];


const profileUrl = "https://www.kaggle.com/ahmadhassan061";
const notebookCode = "https://www.kaggle.com/ahmadhassan061/code";

export default function KaggleSection() {
  return (
    <section className="kaggle-container" id="kaggle">
      <h1>Kaggle Notebooks</h1>

      <div className="featured-notebook">
        <h2>{featuredNotebook.title}</h2>
        <p>{featuredNotebook.description}</p>
        <a href={featuredNotebook.url} target="_blank" rel="noreferrer" className="preview-button">
          🔍 Preview
        </a>
      </div>

   
        <h2> Notebook Collections </h2>
        <p>Each card contains curated sets of data science notebooks grouped by theme, topic, or competition.</p>
        
      <div className="notebooks-grid">
        {notebooks.map((nb, index) => (
          <div className="notebook-card zoom" key={index}>
            <div className="notebook-icon">{nb.icon}</div>
            <a href={nb.url} target="_blank" rel="noreferrer">
              <h2>{nb.title}</h2>
            </a>
            <div className="notebook-tags">
              {nb.tags.map((tag, i) => (
                <span className="tag" key={i}>{tag}</span>
              ))}
            </div>
            <div className="notebook-actions">
              <a href={nb.url} target="_blank" rel="noreferrer" className="preview-button">🔍 Preview</a>
                <button
                className="share-button"
                onClick={() => {
                    if (navigator.clipboard && window.isSecureContext) {
                    navigator.clipboard.writeText(nb.url)
                        .then(() => alert('Link copied to clipboard!'))
                        .catch(err => alert('Failed to copy: ' + err));
                    } else {
                    // Fallback for insecure context or older browsers
                    const textArea = document.createElement('textarea');
                    textArea.value = nb.url;
                    document.body.appendChild(textArea);
                    textArea.focus();
                    textArea.select();
                    try {
                        document.execCommand('copy');
                        alert('Link copied to clipboard!');
                    } catch (err) {
                        alert('Fallback copy failed: ' + err);
                    }
                    document.body.removeChild(textArea);
                    }
                }}
                >
                📤 Share
                </button>
            </div>
          </div>
        ))}
      </div>

      <h2> Fastbook Extended Version</h2>
      <p>Each card contains curated sets of notebooks grouped by Chapters</p>
      
      <div className="notebooks-grid">
        {notebooks1.map((nb, index) => (
          <div className="notebook-card zoom" key={index}>
            <div className="notebook-icon">{nb.icon}</div>
            <a href={nb.url} target="_blank" rel="noreferrer">
              <h2>{nb.title}</h2>
            </a>
            <div className="notebook-tags">
              {nb.tags.map((tag, i) => (
                <span className="tag" key={i}>{tag}</span>
              ))}
            </div>
            <div className="notebook-actions">
              <a href={nb.url} target="_blank" rel="noreferrer" className="preview-button">🔍 Preview</a>
                <button
                className="share-button"
                onClick={() => {
                    if (navigator.clipboard && window.isSecureContext) {
                    navigator.clipboard.writeText(nb.url)
                        .then(() => alert('Link copied to clipboard!'))
                        .catch(err => alert('Failed to copy: ' + err));
                    } else {
                    // Fallback for insecure context or older browsers
                    const textArea = document.createElement('textarea');
                    textArea.value = nb.url;
                    document.body.appendChild(textArea);
                    textArea.focus();
                    textArea.select();
                    try {
                        document.execCommand('copy');
                        alert('Link copied to clipboard!');
                    } catch (err) {
                        alert('Fallback copy failed: ' + err);
                    }
                    document.body.removeChild(textArea);
                    }
                }}
                >
                📤 Share
                </button>
            </div>
          </div>
        ))}
      </div>

      <div className="notebook-footer">
        <a href={profileUrl} target="_blank" rel="noreferrer" className="follow-button">
          Follow on Kaggle
        </a>
        <a href={notebookCode} target="_blank" rel="noreferrer" className="view-more-link">
          [View More]
        </a>
      </div>
    </section>
  );
}
